import PlotlyChart from './PlotlyChart';

export default function LineChart({ data, chartOptions = {}, dimensionInfo }) {
  const { nameFn = (x, _d) => x } = chartOptions

  const traces = data.map(trace => {
    console.log({ chartOptions })
    return {
      x: trace.x,
      y: trace.y,
      type: 'scatter',
      mode: 'lines+markers',
      name: nameFn(trace.name, dimensionInfo)
    }
})

  return (
    <PlotlyChart
      data={traces}
      useResizeHandler={true}
      layout={{ title: 'Sales Over Time', autosize: true }}
      config={{
        displayModeBar: false,
        responsive: true
      }}
      style={{ width: '100%', height: '400px' }}
    />
  );
}
